module.exports = __webpack_public_path__ + "img/footer-map.9fe1c508.png";